import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBJumbotron,  MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon, MDBBadge, MDBInput} from "mdbreact";
import Axios from 'axios'
import { Layout, Menu, Breadcrumb, Icon, Select, Input, Button ,Card ,Alert  } from 'antd';
import { StarOutlined, StarFilled, StarTwoTone, CaretDownOutlined, UserOutlined  } from '@ant-design/icons';
import Modalteachingschedule from './Modalteachingschedule';
import Modalcolor from './Modalcolor';
import Getteachet2 from './Getteachet2';
import Getteachet3 from './Getteachet3';
import Getprograme from './Getprograme';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import Learncheck from './Learncheck';
import Modalroom from './Modalroom';




export default class Learn1 extends Component {
    
    constructor(props) {
        super(props);
        this.state = {

          thschedule:[],
          modal: false,
          term:'1/2568',
          type:'1',
          idemp:'',
          empcouncilcheck:[],
          empcouncilcheck2:[],
          showteachingschedule:[],
          showteachingscheduleall:[],
          dd3:'',
          teacher:'',
          major:'',
          justClicked: null,
          Loadding:false,

        };
        this.onChangemajor = this.onChangemajor.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onSearch = this.onSearch.bind(this);

        this.getthschedule = this.getthschedule.bind(this);
        this.updateSearchDepartment = this.updateSearchDepartment.bind(this);
        this.getteachingschedule = this.getteachingschedule.bind(this);
        this.time = this.time.bind(this);
        this.sentpdf = this.sentpdf.bind(this);
        this.getteachingscheduleall = this.getteachingscheduleall.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.sentnamelistpdf = this.sentnamelistpdf.bind(this);

  
        
      }

      handleClick(letter) {

        this.setState({ justClicked: letter });
      }


    updateSearchDepartment(value) {
        // console.log(event.target.value)
        // const term = event.target.value;
        const term = value;
        this.setState({ term });
 
           setTimeout(() => {
             this.getthschedule()
           }, 500);
      }


      getthschedule() {
        setTimeout(() => {
           //ภายใน
            Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getthschedule/'+this.state.term)
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ thschedule: res.data})
           }) 
         }, 0);
      }

      getteachingschedule() {
         this.setState({ Loadding:true });
        setTimeout(() => {
           //ภายใน
            Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/showstudentschedule/'+this.state.term+'/'+this.state.major)
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
          //  const data11 = res.data;
          //  const showteachingschedule1 = [...data11].sort((a, b) => a.SUBJCODE.substring(0,7) - b.SUBJCODE.substring(0,7));
          
             this.setState({ showteachingschedule: res.data})

             if (res.data.length !== 0) {

              const teacher = res.data[0].poname;
              this.setState({ teacher });
                 this.setState({ Loadding:false });
            }else{
                   this.setState({ Loadding:false });
              Swal.fire({
                title: 'ไม่พบตารางเรียน',
                icon: 'warning',
                text: 'ตรวจสอบการเพิ่มตารางเรียน-สอน' ,
              // showCancelButton: true,
                confirmButtonText: 'ตกลง',
              // cancelButtonText: 'No, keep it'
              }).then((result) => {
              })
            }

           }) 
         }, 0);

     // this.getteachingscheduleall();

      }

      getteachingscheduleall() {
        setTimeout(() => {
           //ภายใน
            Axios.get('https://mua.kpru.ac.th/FrontEnd_Tabian/load/showreportmajor/'+this.state.term+'/'+this.state.major)
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
           const data22 = res.data;
           const showteachingschedule2 = [...data22].sort((a, b) => a.SUBJCODE.substring(0,7) - b.SUBJCODE.substring(0,7));
             this.setState({ showteachingscheduleall: showteachingschedule2})

            //  if (res.data.length !== 0) {
            //   const teacher = res.data[0].poname;
            //   this.setState({ teacher });
            // }          
           }) 
         }, 0);
      }


      sentpdf() {
        setTimeout(() => {
          window.open('https://e-student.kpru.ac.th/tess/tesspdf/TCPDF-main/tesslearn.php?term='+this.state.term+'&idemp='+this.state.major+'', '_blank');
           //  window.open('http://localhost/tesspdf/TCPDF-main/tesslearn.php?term='+this.state.term+'&idemp='+this.state.major+'', '_blank');
           // window.location.href ='http://localhost/tesspdf/TCPDF-main/tess.php?term='+this.state.term+'&idemp='+this.state.idemp 
         }, 0);
      }

      sentnamelistpdf() {
        setTimeout(() => {
       //   window.open('https://e-student.kpru.ac.th/tess/tesspdf/TCPDF-main/tesslearnnamelist.php?term='+this.state.term+'&idemp='+this.state.major+'', '_blank');
             window.open('http://localhost/tesspdf/TCPDF-main/tesslearnnamelist.php?term='+this.state.major+'', '_blank');
           // window.location.href ='http://localhost/tesspdf/TCPDF-main/tess.php?term='+this.state.term+'&idemp='+this.state.idemp 
         }, 0);
      }

    


      onChangemajor= e =>{
       console.log(e.target.value);
         // const idemp = value;
          this.setState({ major:e.target.value });

        //   setTimeout(() => {
        //      Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getthcouncilcheck/1/'+this.state.term+'/'+this.state.idemp)
        //     .then(res => {
        //             this.setState({ empcouncilcheck: res.data})
        //     }) 
        //   }, 0);

        //   setTimeout(() => {
        //      Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getthcouncilcheck/2/'+this.state.term+'/'+this.state.idemp)
        //     .then(res => {
        //             this.setState({ empcouncilcheck2: res.data})
        //     }) 
        //   }, 0);
        //   setTimeout(() => {
        //     this.getteachingschedule()
        //   }, 500);
     }


         onBlur() {
            console.log('blur');
          }
          
           onFocus() {
            console.log('focus');
          }
          
           onSearch(val) {
            console.log('search:', val);
          }

          time() {
            const d = new Date();
            d.setMinutes(17);
            document.getElementById("demo").innerHTML = d;
          }


    render() {




      let sum = this.state.showteachingschedule.reduce(function(prev, current) {
        return prev + +current.CRHR.substring(0, 1)
      }, 0);
      console.log(sum)

        const { Option } = Select;
       // let majorname =  this.state.showteachingschedule[0].map(showteachingschedule => { {showteachingschedule.major} }  )     
        return (
            <MDBContainer fluid>
                {/* <MDBAlert color="primary" >
                <h4><MDBIcon icon="address-book" className="indigo-text pr-3" /> ตารางเรียน </h4>
                </MDBAlert>
                <br/> */}
      <Card type="inner" className="text-center" title={<h5><MDBIcon icon="list-alt" /> ตารางเรียน</h5>} >
    <MDBRow>

            <MDBCol sm="5">
               
                    {/* <br/> */}

            </MDBCol>

            <MDBCol sm="2">
            <div className="text-center">
                   <div className="text-left"><label ><strong>ปีการศึกษา</strong></label></div> 
                    {/* <CaretDownOutlined style={{ fontSize: '30px', color: '#0d47a1' }}  />    */}
                    
                        <Select
                            showSearch
                            style={{ width: 300 }}
                            placeholder="เลือกเทอม"
                            optionFilterProp="children"
                            onChange={this.updateSearchDepartment}
                            onFocus={this.onFocus}
                            onBlur={this.onBlur}
                            onSearch={this.onSearch}
                            value={this.state.term}
                            filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            className="text-left"
                        >
                            {/* <Option value="3/2563">3/2563</Option> */}
                           
                            <Option value="1/2568">1/2568</Option>
                            <Option ative value="3/2567"> 3/2567</Option>
                            <Option value="2/2567">2/2567</Option>
                            <Option value="1/2567">1/2567</Option>
                            <Option ative value="3/2566">3/2566</Option>
                            <Option value="2/2566">2/2566</Option>
                            <Option value="1/2566">1/2566</Option>
                            <Option value="3/2565">3/2565</Option>
                            <Option value="2/2565">2/2565</Option>
                            <Option value="1/2565">1/2565</Option>
                            <Option value="3/2564">3/2564</Option>
                            <Option value="2/2564">2/2564</Option>
                            <Option value="1/2564">1/2564</Option>

                            {/* <Option ative value="3/2568"><span class="green-text">3/2568</span></Option> */}
                        </Select>
                    </div>
                   
          { this.state.term === "" ?<> </>:<> 
  
                        <div className="text-center">
                        <div className="text-left"><label className="text-left mt-2"><strong>รหัสหมู่เรียน</strong></label></div> 
                        {/* <UserOutlined style={{ fontSize: '30px', color: '#0d47a1' }}  />    */}
                        <Input placeholder="หมู่เรียน"  style={{ width: 300 }}  onChange={this.onChangemajor} />
                        {/* <Button type="primary"  onClick={this.getteachingschedule} >ค้นหา</Button> */}
                       </div>
                        
          </> }



          <br/>
          { this.state.term !== "" && this.state.major !== "" ?<> 
            <div className="text-center">
            <Button type="primary"  onClick={this.getteachingschedule} >ค้นหา</Button>
            </div></>:<>  
                      { this.state.term === "" ?<> </>:<>  
                      <div className="text-center">
                      <Button type="primary" disabled  >ค้นหา</Button>
                      </div>  </> }    
                    
             </> }

            </MDBCol>
            <MDBCol sm="5">
          
            
            </MDBCol>
  </MDBRow>

                {/* { this.state.empcouncilcheck.length === 0 ? <> </> : 
                <>
                <MDBAlert color="danger">
                    <a href="#!" className="alert-link"> ! อาจารย์มีรายชื่อในการประชุมกรรมการบริหารมหาวิทยาลัย</a> ทุกวันอังคาร ของทุกเดือน
                </MDBAlert>
                </>}


                { this.state.empcouncilcheck2.length === 0 ? <> </> : 
                <>
                <MDBAlert color="warning ">
                    <a href="#!" className="alert-link"> ! อาจารย์มีรายชื่อในการประชุมกรรมการบริหารมหาวิทยาลัย</a> ทุกวันพฤหัสบดี ของทุกเดือน
                </MDBAlert>
                </>} */}

          { this.state.term === '' ? <></> :<> 
          <br/>
          <hr/>
          {/* <h5 className="text-center">ตารางเรียนภาคปกติกำแพงเพชร</h5>  */}
           <h5 className="text-center">ตารางเรียน ปีการศึกษา {this.state.term}</h5> 
         
              {/* <h5>{this.majorname}</h5> */}
           {/* {this.state.teacher === ''?<></>:<>  <h5 className="text-center">อาจารย์{this.state.major} </h5> </> } */}

          {this.state.showteachingschedule.length != 0 ?<><h5 className="text-center"><MDBBadge pill color="primary" >หมู่เรียน {this.state.major}</MDBBadge></h5>   
         <div className="text-left"><MDBBtn color="primary" size="sm" onClick={this.sentpdf}><MDBIcon far icon="file-pdf" /> พิมพ์ตารางเรียน</MDBBtn></div>  
           </>:<></>}

           {/* {this.state.major === ''?<></>:<>   <MDBBtn color="primary" size="sm" onClick={this.sentpdf}><MDBIcon far icon="file-pdf" /> พิมพ์</MDBBtn></> } */}
          {this.state.empcouncil === '' ? <>
          <div className="spinner-grow text-primary " role="status">
              <span className="sr-only">Loading...</span>
            </div>
            </>: <>
            <MDBTable  bordered small responsive>
                <MDBTableHead color="grey lighten-1">
                <tr>
                    {/* <th  className="text-center">ลำดับ</th> */}
                    <th  className="text-center">รหัสวิชา</th>
                    <th  className="text-center">ชื่อวิชา</th>
                    <th  className="text-center">หน่วยกิต</th>
                    <th  className="text-center">หมู่เรียน</th>
                    <th  className="text-center">โปรแกรม</th>
                     <th  className="text-center">จำนวน</th>
                    <th  className="text-center">ผู้สอน</th>
                   
                    {/* <th  className="text-center">กลุ่ม</th> */}
                    <th  className="text-center">วัน</th>
                    <th  className="text-center">เวลา</th>
                    <th  className="text-center">ห้องเรียน</th>
                </tr>
              
                </MDBTableHead>

                 {this.state.Loadding === true ? <>
                
                    <div className="spinner-border text-left" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                    
                            </>: <>
                <MDBTableBody>
                {this.state.showteachingschedule.map((showteachingschedule,index) => {
                
                   //กศบป
                    const  time2 = Number (showteachingschedule.hour1*55)
                    const  ddf = time2-5
                    const  now = new Date("December 25, 1995 "+showteachingschedule.times1+" ");
                    const totalsss = now.setMinutes(now.getMinutes()+ddf);
                    const wanwela = new Date(totalsss)
                    const wanwela1 =  wanwela.toLocaleTimeString()

                    //ปกติ
                    const  timenormal = Number (showteachingschedule.hour1*60)
                    const  now2 = new Date("December 25, 1995 "+showteachingschedule.times1+" ");
                    const totalsss2 = now2.setMinutes(now2.getMinutes()+timenormal);
                    const wanwela2 = new Date(totalsss2)
                    const normal =  wanwela2.toLocaleTimeString()
                       
                     return   <tr>
                          {/* <td>{index+1}</td> */}
                          <td>{showteachingschedule.SUBJCODE}</td>
                          <td className="text-left">{showteachingschedule.SUBJNAME}</td>
                          <td>{showteachingschedule.CRHR}</td>
                          <td>{showteachingschedule.id_major} </td>
                          {/* <td>{showteachingschedule.major} <Getprograme id_major = {showteachingschedule.id_major} /></td> */}
                          <td className="text-left">
                          {showteachingschedule.t_mjnamecheck}
                            {/* <Getprograme id_major = {showteachingschedule.id_major} /> */}
                            </td>
                          <td>{showteachingschedule.numregister}</td>
                          <td className="text-left">
                                        {showteachingschedule.prenmth1}{showteachingschedule.nameth1}  
                                        {showteachingschedule.nameth2 !== null ? <>, {showteachingschedule.prenmth2}{showteachingschedule.nameth2}</> : <></>} 
                                        {showteachingschedule.nameth3 !== null ? <>, {showteachingschedule.prenmth3}{showteachingschedule.nameth3}</> : <></>} 
                                        {showteachingschedule.nameth4 !== null ? <>, {showteachingschedule.prenmth4}{showteachingschedule.nameth4}</> : <></>} 
                                        {showteachingschedule.nameth5 !== null ? <>, {showteachingschedule.prenmth5}{showteachingschedule.nameth5}</> : <></>} 
                                        {showteachingschedule.nameth6 !== null ? <>, {showteachingschedule.prenmth6}{showteachingschedule.nameth6}</> : <></>} 
                                        {showteachingschedule.nameth7 !== null ? <>, {showteachingschedule.prenmth7}{showteachingschedule.nameth7}</> : <></>} 
                                        {showteachingschedule.nameth8 !== null ? <>, {showteachingschedule.prenmth8}{showteachingschedule.nameth8}</> : <></>} 
                                        {/* {showteachingschedule.prenm}{showteachingschedule.poname} {showteachingschedule.teacher_id2 != null ?<><Getteachet2 teacher_id2={showteachingschedule.teacher_id2}  /> </>:<></>}
                          {showteachingschedule.teacher_id3 != null ?<><Getteachet2 teacher_id2={showteachingschedule.teacher_id3}  /> </>:<></>}
                          {showteachingschedule.teacher_id4 != null ?<><Getteachet2 teacher_id2={showteachingschedule.teacher_id4}  /> </>:<></>}
                          {showteachingschedule.teacher_id5 != null ?<><Getteachet2 teacher_id2={showteachingschedule.teacher_id5}  /> </>:<></>}
                          {showteachingschedule.teacher_id6 != null ?<><Getteachet2 teacher_id2={showteachingschedule.teacher_id6}  /> </>:<></>}
                          {showteachingschedule.teacher_id7 != null ?<><Getteachet2 teacher_id2={showteachingschedule.teacher_id7}  /> </>:<></>}
                          {showteachingschedule.teacher_id8 != null ?<><Getteachet2 teacher_id2={showteachingschedule.teacher_id8}  /> </>:<></>}
                          {showteachingschedule.teacher_id9 != null ?<><Getteachet2 teacher_id2={showteachingschedule.teacher_id9}  /> </>:<></>}
                          {showteachingschedule.teacher_id10 != null ?<><Getteachet2 teacher_id2={showteachingschedule.teacher_id10}  /> </>:<></>} */}
                           </td>
                         
                          {/* <td> <p><Modalcolor idcolor={teachingschedule.group_id} /></p></td> */}
                          {/* <td>อาจารย์{teachingschedule.poname}</td>Getteachet2 */}

                    {/* ช่วงที่1 */}
                          <td> {showteachingschedule.ss === '1' ?<> จันทร์</>:<></> }
                               {showteachingschedule.ss === '2' ?<> อังคาร</>:<></> }
                               {showteachingschedule.ss === '3' ?<> พุธ</>:<></> }
                               {showteachingschedule.ss === '4' ?<> พฤหัสบดี</>:<></> }
                               {showteachingschedule.ss === '5' ?<> ศุกร์</>:<></> }
                               {showteachingschedule.ss === '6' ?<> เสาร์</>:<></> }
                               {showteachingschedule.ss === '7' ?<> อาทิตย์</>:<></> }
                               {showteachingschedule.ss === '8' ?<> ----</>:<></> }
                          </td>
                          <td>
                              {showteachingschedule.times1 === null || showteachingschedule.times1 === ''  ? <></> :<>
                              {showteachingschedule.ss === '8' ?<> ----</>:<>
                                {showteachingschedule.day === 'weekly2' ?<>{showteachingschedule.times2} - {showteachingschedule.timesend2}</>:<>{showteachingschedule.times1} - {showteachingschedule.timesend1}</>}
                              </> }
                            
                               
                              {/* { showteachingschedule.id_major.substring(2, 3) === '1' ?<>{normal.substring(0, 5)} </> :<>{wanwela1.substring(0, 5)}  </>} */}
                                </> }
                          </td>
                        <td >
                        {showteachingschedule.ss === '8' ?<> ----</>:<>
                        {showteachingschedule.day === 'weekly1'?<>
                        {showteachingschedule.classroom1.substring(0, 2) ==='99'?<>
                                <Modalroom idroom={showteachingschedule.classroom1} />
                                </>:<> {showteachingschedule.classroom1} </>}
                        </>:<>
                              {showteachingschedule.day === 'weekly2'?<>
                              {showteachingschedule.classroom2.substring(0, 2) ==='99'?<>
                                <Modalroom idroom={showteachingschedule.classroom2} />
                                </>:<> {showteachingschedule.classroom2} </>}
                              </>:<>
                                                                                                                {showteachingschedule.day === 'weekly3'?<>
                                                                                                                {showteachingschedule.classroom3.substring(0, 2) ==='99'?<>
                                                                                                                    <Modalroom idroom={showteachingschedule.classroom3} />
                                                                                                                    </>:<> {showteachingschedule.classroom3} </>}
                                                                                                                </>:<>
                                                                                                                                                                                       {showteachingschedule.day === 'weekly4'?<>
                                                                                                                                                                                       {showteachingschedule.classroom4.substring(0, 2) ==='99'?<>
                                                                                                                                                                                        <Modalroom idroom={showteachingschedule.classroom4} />
                                                                                                                                                                                        </>:<> {showteachingschedule.classroom4} </>}
                                                                                                                                                                                       </>:<>ไม่พบห้อง</>}
                                                                                                                </>}
                                                                                                              </>}
                         </>}
                        </> }
                           </td>
                          </tr>
                  
                })}   
                </MDBTableBody>
            </>}
            </MDBTable>
            {sum === 0?<></>:<> <div className="text-left"> <MDBBadge pill color="primary" >หน่วยกิตรวม {sum} หน่วยกิต</MDBBadge></div>  </>}

            {/* <h5 className="text-center">วิชาทั้งหมด</h5>
          <MDBTable  bordered small responsive>
          <MDBTableHead color="grey lighten-1">
            <tr>
              <th>ลำดับ</th>
              <th>รหัสวิชา</th>
              <th>ชื่อวิชา</th>
              <th>หน่วยกิต</th>
              <th>หมู่เรียน</th>
              <th>โปรแกรม</th>
              <th>ผู้สอนหลัก</th>
              <th>สถานะ</th>
            </tr>
          </MDBTableHead>
          <MDBTableBody>
          {this.state.showteachingscheduleall.map((showteachingscheduleall,index) => {
            const letter = index+1;
           return <tr>
              <td>{index+1}</td>
              <td>{showteachingscheduleall.SUBJCODE}</td>
              <td>{showteachingscheduleall.SUBJNAME}</td>
              <td>{showteachingscheduleall.CRHR}</td>
              <td>{showteachingscheduleall.id_major}</td>
              <td>{showteachingscheduleall.t_mjnamecheck}</td>
              <td>{showteachingscheduleall.pname}{showteachingscheduleall.poname}</td>
              <td className="text-center">
                <Learncheck term={this.state.term} major={this.state.major} SUBJCODE={showteachingscheduleall.SUBJCODE} />
               
              </td>         
            </tr>
         })}   
          </MDBTableBody>
        </MDBTable>
        <MDBBadge pill color="primary">   <MDBIcon icon="thumbs-up" className="green-text pr-3" />= เพิ่มข้อมูลแล้ว,  <MDBIcon icon="thumbs-down" className="red-text pr-3" />= ยังไม่เพิ่มข้อมูล  </MDBBadge>
       */}
        {/* <h5 className="text-center">ข้อมูลแผนการเรียน</h5> */}
 
            </> }
            
        </>}

       
        </Card>
            </MDBContainer>
        )
    }
}
